import './filter-button.scss';

import { PropsWithChildren } from 'react';

type FilterButtonProps = PropsWithChildren<{
  active: boolean;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void | Promise<void>;
}>;

export function FilterButton({
  active,
  loading,
  disabled,
  onClick,
  children,
}: FilterButtonProps) {
  return (
    <button
      type="button"
      className={`filter-button${active ? ' filter-button--active' : ''}${loading ? ' filter-button--loading' : ''}`}
      disabled={loading ?? disabled}
      onClick={onClick}
    >
      {loading && <span className="filter-button__spinner" />}
      {children}
    </button>
  );
}
